import React, { useState, useEffect, useCallback, useRef } from "react";
import api, { apiError } from "../api";
import { toast } from "sonner";

const box = { fontFamily: "Arial, sans-serif", fontSize: "14px", color: "#000000", background: "#ffffff" };
const sectionStyle = { border: "1px solid #000", padding: "12px", marginBottom: "16px", background: "#fff" };
const titleStyle = { fontWeight: "bold", fontSize: "14px", marginBottom: "10px", textTransform: "uppercase" };
const btnStyle = { fontFamily: "Arial", fontSize: "14px", color: "#000", background: "#fff", border: "1px solid #000", padding: "6px 12px", cursor: "pointer", marginRight: "6px", marginBottom: "6px" };
const btnPrimary = { ...btnStyle, background: "#000", color: "#fff", fontWeight: "bold" };
const btnRed = { ...btnStyle, background: "#cc0000", color: "#fff", fontWeight: "bold", border: "1px solid #cc0000" };
const inputStyle = { fontFamily: "Arial", fontSize: "14px", color: "#000", background: "#fff", border: "1px solid #000", padding: "4px 6px", width: "100%", boxSizing: "border-box" };

export default function CampaniiTenant() {
  const [tenants, setTenants] = useState([]);
  const [tari, setTari] = useState([]);
  const [judete, setJudete] = useState([]);
  const [domeniiGroups, setDomeniiGroups] = useState([]);

  const [tenantId, setTenantId] = useState("");
  const [nume, setNume] = useState("");
  const [tintaLead, setTintaLead] = useState("");
  const [subiect, setSubiect] = useState("");
  const [text, setText] = useState("");
  const [selTari, setSelTari] = useState([]);
  const [selJudete, setSelJudete] = useState([]);
  const [selDomenii, setSelDomenii] = useState([]);

  const [rataConversie, setRataConversie] = useState(1);
  const [marja, setMarja] = useState(10);
  const [oraStart, setOraStart] = useState(9);
  const [oraStop, setOraStop] = useState(17);

  const RAMP_ZILE = [100, 200, 300, 400, 500];

  const [saving, setSaving] = useState(false);
  const [drafts, setDrafts] = useState([]);
  const [poolDisp, setPoolDisp] = useState(null);
  const [poolLoading, setPoolLoading] = useState(false);
  const [exporting, setExporting] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiDone, setAiDone] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const textRef = useRef(null);

  const LINK_TOKEN = "{{LINK_ACTIVARE}}";
  const insertLinkToken = () => {
    const el = textRef.current;
    if (!el) { setText((p) => p + LINK_TOKEN); return; }
    const start = el.selectionStart ?? text.length;
    const end = el.selectionEnd ?? text.length;
    setText(text.slice(0, start) + LINK_TOKEN + text.slice(end));
    setTimeout(() => {
      el.focus();
      const pos = start + LINK_TOKEN.length;
      el.setSelectionRange(pos, pos);
    }, 0);
  };
  const hasLinkToken = text.includes(LINK_TOKEN);

  const loadOptiuni = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/campanii-tenant/optiuni");
      setTenants(data.tenants || []);
      setTari(data.tari || []);
      setJudete(data.judete || []);
      setDomeniiGroups(data.domenii_groups || []);
    } catch (e) { toast.error(apiError(e, "Eroare la incarcarea optiunilor")); }
  }, []);

  const loadDrafts = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/campanii-tenant");
      setDrafts(data.items || []);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => { loadOptiuni(); loadDrafts(); }, [loadOptiuni, loadDrafts]);

  const selectedTenant = tenants.find((t) => t.id === tenantId);
  const subdomain = selectedTenant ? selectedTenant.subdomain : "";

  const rataNum = parseFloat(rataConversie) || 0;
  const marjaNum = parseFloat(marja) || 0;
  const tintaNum = parseInt(tintaLead || "0", 10) || 0;
  const poolNecesar = tintaNum > 0 && rataNum > 0 ? Math.ceil(tintaNum / (rataNum / 100)) : 0;
  const poolFinal = Math.ceil(poolNecesar * (1 + (marjaNum > 0 ? marjaNum : 0) / 100));
  const ore = Math.max(1, (parseInt(oraStop, 10) || 0) - (parseInt(oraStart, 10) || 0));
  const totalRamp = RAMP_ZILE.reduce((a, b) => a + b, 0);

  const toggle = (arr, setArr, id) => {
    if (id === "all") { setArr(arr.includes("all") ? [] : ["all"]); return; }
    let next = arr.filter((x) => x !== "all");
    if (next.includes(id)) next = next.filter((x) => x !== id);
    else next = [...next, id];
    setArr(next);
  };

  const CheckList = ({ items, sel, setSel, labelKey, idKey, testid }) => (
    <div data-testid={testid} style={{ maxHeight: "180px", overflowY: "auto", border: "1px solid #000", padding: "6px" }}>
      <label style={{ display: "block", marginBottom: "4px" }}>
        <input type="checkbox" checked={sel.includes("all")} onChange={() => toggle(sel, setSel, "all")}
          data-testid={`${testid}-all`} /> Toate
      </label>
      {items.map((it) => (
        <label key={it[idKey]} style={{ display: "block", marginBottom: "2px" }}>
          <input type="checkbox" checked={sel.includes(it[idKey])} disabled={sel.includes("all")}
            onChange={() => toggle(sel, setSel, it[idKey])} /> {it[labelKey]}
        </label>
      ))}
    </div>
  );

  const resetForm = () => {
    setNume(""); setTintaLead(""); setSubiect(""); setText("");
    setSelTari([]); setSelJudete([]); setSelDomenii([]);
    setRataConversie(1); setMarja(10); setOraStart(9); setOraStop(17);
  };

  const handleSave = async () => {
    if (!tenantId) { toast.error("Selectati un tenant"); return; }
    if (!subiect.trim() || !text.trim()) { toast.error("Completati subiect si text"); return; }
    setSaving(true);
    try {
      await api.post("/admin/campanii-tenant", {
        tenant_id: tenantId, nume, tinta_lead: tintaNum, subiect, text,
        tara_ids: selTari, judet_ids: selJudete, domeniu_ids: selDomenii,
        rata_conversie: rataNum, marja: marjaNum,
        ora_start: parseInt(oraStart, 10) || 0, ora_stop: parseInt(oraStop, 10) || 0,
        ramp_zile: RAMP_ZILE,
      });
      toast.success("Campanie salvata (draft)");
      resetForm();
      loadDrafts();
    } catch (e) {
      toast.error(apiError(e, "Eroare la salvare"));
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admin/campanii-tenant/${id}`);
      loadDrafts();
    } catch (e) { toast.error(apiError(e, "Eroare la stergere")); }
  };

  const selectedTaraNames = () => {
    if (selTari.includes("all") || selTari.length === 0) return "";
    return tari.filter((t) => selTari.includes(t.id)).map((t) => t.nume).join(",");
  };

  const selectedDomeniiIds = () => selDomenii.filter((x) => x !== "all");

  const checkPool = async () => {
    setPoolLoading(true);
    setPoolDisp(null);
    try {
      const names = selectedTaraNames();
      const doms = selectedDomeniiIds();
      const p = new URLSearchParams();
      if (names) p.set("tari", names);
      if (doms.length > 0) p.set("domenii", doms.join(","));
      const q = p.toString() ? `?${p.toString()}` : "";
      const { data } = await api.get(`/admin/campanii-tenant/pool-disponibil${q}`);
      if (!data.disponibil) { toast.error(`Pool indisponibil: ${data.reason || "eroare"}`); }
      setPoolDisp(data);
    } catch (e) { toast.error(apiError(e, "Eroare la verificarea poolului")); }
    finally { setPoolLoading(false); }
  };

  const handleGenerateAi = async () => {
    if (!tenantId) { toast.error("Selectati un tenant"); return; }
    setAiLoading(true);
    try {
      const { data } = await api.post("/admin/campanii-tenant/genereaza-ai", { tenant_id: tenantId });
      if (data.subiect) setSubiect(data.subiect);
      if (data.text) setText(data.text);
      if (Array.isArray(data.domeniu_ids)) setSelDomenii(data.domeniu_ids);
      setAiDone(true);
      toast.success("Text generat cu AI. Verifica si editeaza inainte de salvare.");
    } catch (e) {
      toast.error(apiError(e, "Eroare la generarea cu AI"));
    } finally { setAiLoading(false); }
  };

  const emailPreviewNodes = () => {
    const parts = (text || "").split(LINK_TOKEN);
    const nodes = [];
    parts.forEach((seg, i) => {
      nodes.push(<span key={`s${i}`} style={{ whiteSpace: "pre-wrap" }}>{seg}</span>);
      if (i < parts.length - 1) {
        nodes.push(
          <div key={`b${i}`} style={{ margin: "14px 0" }}>
            <span style={{ display: "inline-block", background: "#000", color: "#fff", padding: "10px 22px", fontWeight: "bold", borderRadius: "3px" }}>
              clic aici
            </span>
          </div>
        );
      }
    });
    return nodes;
  };

  const handleExport = async (id) => {
    setExporting(id);
    try {
      const { data } = await api.post(`/admin/campanii-tenant/${id}/export`);
      toast.success(`Exportat pe serverul campanii ca "${data.campaign}"`);
      loadDrafts();
    } catch (e) { toast.error(apiError(e, "Eroare la export")); }
    finally { setExporting(""); }
  };

  return (
    <div style={{ ...box, padding: "24px", minHeight: "100%" }} data-testid="campanii-tenant-page">
      <h1 style={{ fontFamily: "Arial", fontSize: "16px", fontWeight: "bold", marginBottom: "16px" }}>
        CAMPANII TENANT - TARGETARE
      </h1>

      <div style={sectionStyle}>
        <div style={titleStyle}>A. Tenant si campanie</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Tenant:</div>
            <select value={tenantId} onChange={(e) => setTenantId(e.target.value)}
              style={inputStyle} data-testid="ct-tenant-select">
              <option value="">-- Selecteaza tenant --</option>
              {tenants.map((t) => (
                <option key={t.id} value={t.id}>{t.name} ({t.slug})</option>
              ))}
            </select>
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Nume campanie (optional):</div>
            <input value={nume} onChange={(e) => setNume(e.target.value)} style={inputStyle} data-testid="ct-nume" />
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          Link branded (auto): <b data-testid="ct-subdomain">{subdomain || "-"}</b>
        </div>
        <div style={{ marginTop: "10px", width: "160px" }}>
          <div style={{ marginBottom: "4px" }}>Tinta lead-uri:</div>
          <input type="text" inputMode="numeric" value={tintaLead}
            onChange={(e) => setTintaLead(e.target.value.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, ""))}
            style={inputStyle} data-testid="ct-tinta" />
        </div>
      </div>

      <div style={sectionStyle}>
        <div style={titleStyle}>B. Mesaj</div>
        <div style={{ marginBottom: "10px", paddingBottom: "10px", borderBottom: "1px dashed #000" }}>
          <button type="button" style={{ ...btnPrimary, opacity: aiLoading ? 0.6 : 1 }}
            onClick={handleGenerateAi} disabled={aiLoading} data-testid="ct-ai-generate">
            {aiLoading ? "Se genereaza cu AI..." : (aiDone ? "Genereaza din nou cu AI" : "Genereaza subiect, text si domenii cu AI")}
          </button>
          {aiDone && (
            <button type="button" style={{ ...btnStyle, opacity: aiLoading ? 0.6 : 1 }}
              onClick={handleGenerateAi} disabled={aiLoading} data-testid="ct-ai-regenerate">
              Regenereaza alta varianta
            </button>
          )}
          <div style={{ marginTop: "6px", fontSize: "14px" }} data-testid="ct-ai-nota">
            AI citeste pagina publica a tenantului selectat si propune subiect, text (cu {LINK_TOKEN}) si domenii tinta.
            Tara o alegi manual. Textul ramane editabil. Poti regenera pentru o alta varianta.
          </div>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <div>Subiect:</div>
          <input value={subiect} onChange={(e) => setSubiect(e.target.value)} style={inputStyle} data-testid="ct-subiect" />
        </div>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Text:</span>
            <button type="button" style={btnStyle} onClick={insertLinkToken} data-testid="ct-insert-link">
              Insereaza link activare
            </button>
          </div>
          <textarea ref={textRef} value={text} onChange={(e) => setText(e.target.value)} rows={10}
            style={{ ...inputStyle, resize: "vertical" }} data-testid="ct-text" />
          <div style={{ marginTop: "6px", fontSize: "14px" }} data-testid="ct-link-nota">
            Foloseste butonul pentru a insera {LINK_TOKEN} acolo unde vrei sa apara linkul de activare.
            In email va aparea ca buton "clic aici", individual per destinatar, nu ca text lung. Nu modifica acest cod.
          </div>
          {text.trim() && !hasLinkToken && (
            <div style={{ marginTop: "4px", fontSize: "14px", color: "#cc0000" }} data-testid="ct-link-warning">
              Atentie: textul nu contine {LINK_TOKEN}. Destinatarii nu vor avea buton de activare.
            </div>
          )}
          <div style={{ marginTop: "10px" }}>
            <button type="button" style={btnStyle} onClick={() => setShowPreview((p) => !p)}
              disabled={!subiect.trim() && !text.trim()} data-testid="ct-preview-toggle">
              {showPreview ? "Ascunde previzualizarea" : "Previzualizeaza emailul"}
            </button>
          </div>
          {showPreview && (
            <div style={{ marginTop: "10px", border: "1px solid #000", background: "#f7f7f7", padding: "12px" }} data-testid="ct-email-preview">
              <div style={{ fontSize: "14px", color: "#555", marginBottom: "8px" }}>
                Asa vede destinatarul emailul. Tokenul {LINK_TOKEN} devine butonul de activare, individual per destinatar.
              </div>
              <div style={{ border: "1px solid #ccc", background: "#fff", padding: "16px" }}>
                <div style={{ borderBottom: "1px solid #eee", paddingBottom: "8px", marginBottom: "12px" }}>
                  <span style={{ color: "#555" }}>Subiect: </span>
                  <b data-testid="ct-preview-subiect">{subiect || "(fara subiect)"}</b>
                </div>
                <div style={{ fontSize: "14px", lineHeight: "1.5", color: "#000" }} data-testid="ct-preview-body">
                  {emailPreviewNodes()}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={sectionStyle}>
        <div style={titleStyle}>C. Targetare</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Tari:</div>
            <CheckList items={tari} sel={selTari} setSel={setSelTari} labelKey="nume" idKey="id" testid="ct-tari" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Judete (RO):</div>
            <CheckList items={judete} sel={selJudete} setSel={setSelJudete} labelKey="nume" idKey="id" testid="ct-judete" />
          </div>
        </div>
        <div>
          <div style={{ marginBottom: "4px" }}>Domenii de interes:</div>
          {domeniiGroups.length === 0
            ? <div style={{ fontSize: "14px" }}>Domeniile se incarca...</div>
            : (
              <div data-testid="ct-domenii" style={{ maxHeight: "260px", overflowY: "auto", border: "1px solid #000", padding: "8px", columnCount: 2, columnGap: "24px" }}>
                {domeniiGroups.map((g) => (
                  <div key={g.categorie} style={{ breakInside: "avoid", marginBottom: "8px" }}>
                    <div style={{ fontWeight: "bold", marginBottom: "3px" }}>{g.categorie}</div>
                    {g.items.map((it) => (
                      <label key={it.id} style={{ display: "block", marginBottom: "2px" }}>
                        <input type="checkbox" checked={selDomenii.includes(it.id)}
                          onChange={() => setSelDomenii((prev) => prev.includes(it.id) ? prev.filter((x) => x !== it.id) : [...prev, it.id])}
                          data-testid={`ct-domeniu-${it.id}`} /> {it.nume}
                      </label>
                    ))}
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>

      <div style={sectionStyle} data-testid="ct-calculator">
        <div style={titleStyle}>E. Calculator pool si esalonare</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", marginBottom: "12px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Rata conversie (clic activare cont) %:</div>
            <input type="number" step="0.01" min="0" value={rataConversie}
              onChange={(e) => setRataConversie(e.target.value)}
              style={inputStyle} data-testid="ct-rata" />
            <div style={{ marginTop: "6px" }}>
              <button style={btnStyle} onClick={() => setRataConversie(0.05)} data-testid="ct-rata-005">0.05%</button>
              <button style={btnStyle} onClick={() => setRataConversie(1)} data-testid="ct-rata-1">1%</button>
              <button style={btnStyle} onClick={() => setRataConversie(3)} data-testid="ct-rata-3">3%</button>
            </div>
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Marja siguranta %:</div>
            <input type="number" step="1" min="0" value={marja}
              onChange={(e) => setMarja(e.target.value)}
              style={inputStyle} data-testid="ct-marja" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Tinta lead-uri:</div>
            <div data-testid="ct-tinta-echo" style={{ padding: "4px 6px", border: "1px solid #000" }}>{tintaNum}</div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
          <div style={{ border: "1px solid #000", padding: "8px" }}>
            <div>Pool necesar (tinta / rata):</div>
            <div style={{ fontWeight: "bold", fontSize: "14px" }} data-testid="ct-pool-necesar">{poolNecesar}</div>
          </div>
          <div style={{ border: "1px solid #000", padding: "8px" }}>
            <div>Pool final (cu marja {marjaNum || 0}%):</div>
            <div style={{ fontWeight: "bold", fontSize: "14px" }} data-testid="ct-pool-final">{poolFinal}</div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", marginBottom: "12px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Ora incepere (0-23):</div>
            <input type="number" min="0" max="23" value={oraStart}
              onChange={(e) => setOraStart(e.target.value)} style={inputStyle} data-testid="ct-ora-start" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Ora terminare (0-24):</div>
            <input type="number" min="0" max="24" value={oraStop}
              onChange={(e) => setOraStop(e.target.value)} style={inputStyle} data-testid="ct-ora-stop" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Ore fereastra:</div>
            <div data-testid="ct-ore" style={{ padding: "4px 6px", border: "1px solid #000" }}>{ore}</div>
          </div>
        </div>

        <div style={{ marginBottom: "6px" }}>Esalonare zilnica (maxime pe zi si pe tenant), trimitere aleatorie in fereastra:</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }} data-testid="ct-ramp-table">
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Zi</th>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Maxim emailuri</th>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Emailuri / ora ({ore}h)</th>
            </tr>
          </thead>
          <tbody>
            {RAMP_ZILE.map((cap, i) => (
              <tr key={i} data-testid={`ct-ramp-zi-${i + 1}`}>
                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>Ziua {i + 1}</td>
                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{cap}</td>
                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{Math.ceil(cap / ore)}</td>
              </tr>
            ))}
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold" }}>Total (5 zile)</td>
              <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold" }} data-testid="ct-ramp-total">{totalRamp}</td>
              <td style={{ border: "1px solid #000", padding: "4px" }}></td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: "6px", fontSize: "14px" }}>
          Nota: dupa ziua 5 trimiterea se opreste.
        </div>

        <div style={{ marginTop: "14px", borderTop: "1px solid #000", paddingTop: "12px" }} data-testid="ct-pool-disponibil">
          <div style={{ fontWeight: "bold", marginBottom: "6px" }}>Pool disponibil (server campanii)</div>
          <div style={{ fontSize: "14px", marginBottom: "8px" }}>
            Numar real de adrese business disponibile pe serverul de campanii, filtrat pe tarile bifate
            si pe domeniile bifate (mapate la coduri NACE). Fara Rusia. Judetul nu se aplica (nu exista in baza).
          </div>
          <button style={btnStyle} onClick={checkPool} disabled={poolLoading} data-testid="ct-pool-check">
            {poolLoading ? "Se verifica..." : "Verifica pool disponibil"}
          </button>
          {poolDisp && poolDisp.disponibil && (
            <div style={{ marginTop: "10px" }} data-testid="ct-pool-rezultat">
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "10px" }}>
                <div style={{ border: "1px solid #000", padding: "8px" }}>
                  <div>Disponibil (tari selectate):</div>
                  <div style={{ fontWeight: "bold", fontSize: "14px" }} data-testid="ct-pool-disp-total">{poolDisp.total}</div>
                </div>
                <div style={{ border: "1px solid #000", padding: "8px" }}>
                  <div>Pool final necesar:</div>
                  <div style={{ fontWeight: "bold", fontSize: "14px" }}>{poolFinal}</div>
                  {poolFinal > 0 && (
                    <div style={{ marginTop: "4px", fontWeight: "bold",
                      color: poolDisp.total >= poolFinal ? "#0a7d2c" : "#cc0000" }} data-testid="ct-pool-verdict">
                      {poolDisp.total >= poolFinal
                        ? "Suficient"
                        : `Insuficient (lipsesc ${poolFinal - poolDisp.total})`}
                    </div>
                  )}
                </div>
              </div>
              {poolDisp.requested && poolDisp.requested.length > 0 && (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Tara selectata</th>
                      <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Disponibil</th>
                    </tr>
                  </thead>
                  <tbody>
                    {poolDisp.requested.map((r) => (
                      <tr key={r.tara}>
                        <td style={{ border: "1px solid #000", padding: "4px" }}>{r.tara}</td>
                        <td style={{ border: "1px solid #000", padding: "4px" }}>{r.n}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {!poolDisp.requested && (
                <div style={{ fontSize: "14px" }}>Total pe toate tarile (nicio tara bifata = toate).</div>
              )}
            </div>
          )}
        </div>
      </div>

      <button style={{ ...btnPrimary, padding: "10px 20px" }} onClick={handleSave} disabled={saving} data-testid="ct-save-btn">
        {saving ? "Se salveaza..." : "Salveaza campanie (draft)"}
      </button>
      <span style={{ marginLeft: "10px", fontSize: "14px" }}>Trimiterea nu se face acum. Doar se salveaza configuratia.</span>

      <div style={{ ...sectionStyle, marginTop: "24px" }} data-testid="ct-drafts">
        <div style={titleStyle}>D. Campanii salvate</div>
        {drafts.length === 0
          ? <div style={{ fontSize: "14px" }}>Nicio campanie salvata.</div>
          : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Tenant</th>
                  <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Nume</th>
                  <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Subiect</th>
                  <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Tinta</th>
                  <th style={{ border: "1px solid #000", padding: "4px", textAlign: "left" }}>Status</th>
                  <th style={{ border: "1px solid #000", padding: "4px" }}></th>
                </tr>
              </thead>
              <tbody>
                {drafts.map((d) => (
                  <tr key={d.id} data-testid={`ct-draft-${d.id}`}>
                    <td style={{ border: "1px solid #000", padding: "4px" }}>{d.tenant_name}</td>
                    <td style={{ border: "1px solid #000", padding: "4px" }}>{d.nume || "-"}</td>
                    <td style={{ border: "1px solid #000", padding: "4px" }}>{d.subiect}</td>
                    <td style={{ border: "1px solid #000", padding: "4px" }}>{d.tinta_lead}</td>
                    <td style={{ border: "1px solid #000", padding: "4px" }}>{d.status}</td>
                    <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>
                      <button style={btnStyle} onClick={() => handleExport(d.id)}
                        disabled={exporting === d.id} data-testid={`ct-export-${d.id}`}>
                        {exporting === d.id ? "Se exporta..." : "Exporta pe serverul campanii"}
                      </button>
                      <button style={btnRed} onClick={() => handleDelete(d.id)} data-testid={`ct-delete-${d.id}`}>Sterge</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </div>
    </div>
  );
}
